import React from 'react';
import { FaMapMarkerAlt, FaBuilding, FaTag, FaCheck } from 'react-icons/fa';

const AddressListRenderer = ({ data }) => {
  if (!data || !data.addresses || data.addresses.length === 0) {
    return (
      <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
        <div className="flex items-center space-x-2 text-gray-600">
          <FaMapMarkerAlt className="text-sm" />
          <span className="text-sm">No addresses found</span>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {data.message && (
        <div className="text-sm text-gray-600 mb-3">
          {data.message}
        </div>
      )}
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {data.addresses.map((address, index) => (
          <div key={address.addressId || index} className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center space-x-2 mb-2">
                  <FaMapMarkerAlt className="text-blue-500 text-sm" />
                  <h3 className="font-medium text-gray-900">{address.name}</h3>
                  {address.isDefault && (
                    <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                      <FaCheck className="mr-1" />
                      Default
                    </span>
                  )}
                </div>
                
                {address.company && (
                  <div className="flex items-center space-x-2 mb-1">
                    <FaBuilding className="text-gray-400 text-xs" />
                    <span className="text-sm text-gray-600">{address.company}</span>
                  </div>
                )}
                
                <div className="text-sm text-gray-700 space-y-1 break-words">
                  <div>{address.addressLine1}</div>
                  {address.addressLine2 && <div>{address.addressLine2}</div>}
                  <div>{address.city}, {address.state} {address.postalCode}</div>
                  <div>{address.country}</div>
                </div>
                
                {address.tags && address.tags.length > 0 && (
                  <div className="flex items-center space-x-2 mt-3">
                    <FaTag className="text-gray-400 text-xs" />
                    <div className="flex flex-wrap gap-1">
                      {address.tags.map((tag, tagIndex) => (
                        <span 
                          key={tagIndex}
                          className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AddressListRenderer;
